import { Component, computed, signal, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';

import { eLead } from '../../core/services/entities';

import { GsapService } from '../../core/services/gsap.service';
import { HaylieService } from '../../core/services/haylie.service';
import { ModalService } from '../../core/services/modal.service';
import { MasterService } from '../../core/services/master.service';
import { SignalService } from '../../core/services/signal.service';
import { VesperService } from '../../core/services/vesper.service';
import { BtnComponent } from '../../shared/btn.component/btn.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight, faArrowLeft, faLock, faCheckDouble, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-joinus.component',
  imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective, FontAwesomeModule, BtnComponent],
  templateUrl: './joinus.component.html',
  styleUrl: './joinus.component.scss',
})
export class JoinusComponent {
  faArrow = faArrowRight;
  faBack = faArrowLeft;
  faLock = faLock;
  faCheck = faCheckDouble;
  faMapMarkerAlt=faMapMarkerAlt;
  faWhatsapp=faWhatsapp;

  s_frm_name = signal(true);
  s_frm_mail = signal(true);
  s_frm_phone = signal(true);

  frmname = new FormControl('');
  frmmail = new FormControl('');
  frmphone = new FormControl('');

  s_modal = Inject(ModalService).modal;
  s_loading = Inject(SignalService).frm_loading;
  b_loading = computed(() => this.s_loading());

  str_title = "PRÉ-INSCRIÇÃO";
  str_sub = "VAGAS LIMITADAS";
  str_label = "Informe seu nome";
  str_btn = "PRÓXIMO";
  str_step = "0";
  private readonly loadedBackgrounds = new Set([1]);

  constructor(private gsap: GsapService, 
              private haylie: HaylieService,
              private vesper: VesperService, 
              private _svc_modal:ModalService, 
              private _svc_master:MasterService, 
              private _svc_signal:SignalService
            ) 
  {
    this.s_modal = this._svc_modal.modal;
    this.s_loading = this._svc_signal.frm_loading;
  }

  ngOnInit() { 
    //this.gsap.anima_trg("init-preh-setup"); 
    this.gsap.anima_trg("init-preh"); 
  }
  
  navigate(p_forward:boolean): void { 
    this.str_step = p_forward ? (parseInt(this.str_step) + 1).toString() : (parseInt(this.str_step) - 1).toString();
    this.str_step = parseInt(this.str_step) > 4 ? "0" : this.str_step;
    let icheck = true;

    switch(this.str_step) {
      case "0":
        this.gsap.anima_trg('init-preh-setup'); 
        this.gsap.anima_trg('init-preh'); 
        break;

      case "1": 
        const addedBackground = this.loadBackground(2);
        this.str_sub = "VAGAS LIMITADAS ";
        this.str_label = "Informe seu nome";
        this.str_btn = "PRÓXIMO";

        this.animateStep(this.str_step, addedBackground);

        break;

      case "2": 

        if (this.frmname.value == null) icheck = false;
        else {  
          if (this.frmname.value.length <= 0) icheck = false;
        }
        if (!icheck) {
          this.s_frm_name.set(false);
          this.str_step = !p_forward ? (parseInt(this.str_step) + 1).toString() : (parseInt(this.str_step) - 1).toString();
    
          return;
        }

        this.str_sub = "VAGAS LIMITADAS ";
        this.str_label = "Informe seu e-mail";
        this.str_btn = "CONTINUAR";

        this.gsap.anima_trg('init-preh-step' + this.str_step); 

        break;

      case "3":
        if (this.frmmail.value == null) icheck = false;
        else {  
          if (this.frmmail.value.length <= 0) icheck = false;
        }
        if (!icheck) {
          this.s_frm_mail.set(false);
          this.str_step = !p_forward ? (parseInt(this.str_step) + 1).toString() : (parseInt(this.str_step) - 1).toString();
    
          return;
        }

        this.str_sub = "VAGAS LIMITADAS ";
        this.str_label = "Informe seu telefone";
        this.str_btn = "ENVIAR "; 

        this.gsap.anima_trg('init-preh-step' + this.str_step); 

        break; 

      case "4":
        if (this.frmphone.value == null) icheck = false;
        else {  
          if (this.frmphone.value.length <= 0) icheck = false;
        }
        if (!icheck) {
          this.s_frm_phone.set(false);
          this.str_step = !p_forward ? (parseInt(this.str_step) + 1).toString() : (parseInt(this.str_step) - 1).toString();
    
          return;
        }
        else this.frm_send();

        this.str_title = "INSCRIÇÃO ENVIADA COM SUCESSO ";
        this.str_sub = "Nossa equipe entrará em contato dentro de 24hrs.";
        this.str_label = "";
        this.str_btn = " VOLTAR AO INÍCIO ";
        
        this.animateStep(this.str_step, this.loadBackground(4));
        break; 
    }

  }

  shouldLoadBackground(step: number): boolean {
    return this.loadedBackgrounds.has(step);
  }

  private loadBackground(step: number): boolean {
    if (this.loadedBackgrounds.has(step)) {
      return false;
    }

    this.loadedBackgrounds.add(step);
    return true;
  }

  private animateStep(step: string, waitForRender = false): void {
    const animate = () => this.gsap.anima_trg('init-preh-step' + step);

    if (waitForRender) {
      setTimeout(animate);
      return;
    }

    animate();
  }

  frm_send():void {
   // event.preventDefault();

    var obj = new eLead();
    obj.id = '0';
    this.s_frm_name.set(true);
    this.s_frm_mail.set(true);
    this.s_frm_phone.set(true);

    if (this.frmname.value == null) this.s_frm_name.set(false);
    else {  
      if (this.frmname.value.length <= 0) this.s_frm_name.set(false);
      else 
        obj.name = "CLUB - " + this.frmname.value;
    
    }

    if (this.frmmail.value == null) this.s_frm_mail.set(false);
    else {
      if (this.frmmail.value.length <= 0) this.s_frm_mail.set(false);
      else
        obj.mail =  this.frmmail.value;

    }

    if (this.frmphone.value == undefined) this.s_frm_phone.set(false);
    else {
      if (this.frmphone.value.length <= 0) this.s_frm_phone.set(false);
      else  
        obj.phone =  this.frmphone.value;
    }

    if (this.s_frm_name() && this.s_frm_mail() && this.s_frm_phone()) {
      this._svc_master.trg_master("loading");

      obj.birth = "modal-talk";
      //obj.birth = this._svc_signal.modal_type();
      // if (this._svc_signal.modal_type() == "modal-talk")
      //   this.vesper.send_lead(obj);
      // else 
        this.haylie.send_frm(obj, "talk");
      
    }
    else {
      setTimeout(() => {
        this.s_frm_name.set(true);
        this.s_frm_mail.set(true);
        this.s_frm_phone.set(true);
      }, 3000)
      
    }



  }
}
